import image_a from '../images/artwork/casual, surreal,.jpeg'
import image_b from '../images/artwork/Adult, Disturbing, Dark.png'
import image_c from '../images/artwork/adult, edgy, dark.jpeg'
import image_d from '../images/artwork/adult, scholarly, professional,.png'
import image_e from '../images/artwork/Clean, Silly, Cheerful, Young.jpg'
import image_f from '../images/artwork/dark, spooky, disturbing, adult.jpeg'
import image_g from '../images/artwork/edgy, adult, funny, casual.jpeg'
import image_h from '../images/artwork/edgy, adult, funny.jpg'
import image_i from '../images/artwork/edgy, surreal, professional.jpeg'
import image_j from '../images/artwork/funny, edgy, casual, adult.jpeg'
import image_k from '../images/artwork/funny, edgy.jpg'
import image_l from '../images/artwork/funny, silly, cheerful, friendly, young.jpg'
import image_m from '../images/artwork/inspirational, cheerful, clean, friendly.png'
import image_n from '../images/artwork/inspirational, clean, young, friendly.jpeg'
import image_o from '../images/artwork/inspirational, professional.jpeg'
import image_p from '../images/artwork/Inspirational.jpeg'
import image_q from '../images/artwork/professional, adult.jpeg'
import image_r from '../images/artwork/Professional.jpeg'
import image_s from '../images/artwork/raw, adult, dark.jpg'
import image_t from '../images/artwork/scholarly, adult.jpeg'
import image_u from '../images/artwork/scholarly, casual.jpg'
import image_v from '../images/artwork/scholarly, cheerful, casual, friendly.png'
import image_w from '../images/artwork/scholarly, professional.jpeg'
import image_x from '../images/artwork/scholarly,.jpg'
import image_y from '../images/artwork/scholarly.jpg'
import image_z from '../images/artwork/sexy, professional, adult.jpeg'
import image_aa from '../images/artwork/sexy, adult.jpg'
import image_ab from '../images/artwork/sexy, edgy, casual.jpg'
import image_ac from '../images/artwork/sexy, professional.jpg'
import image_ad from '../images/artwork/silly, funny.jpg'
import image_ae from '../images/artwork/soothing, clean, friendly.jpeg'
import image_af from '../images/artwork/soothing, clean.jpeg'
import image_ag from '../images/artwork/soothing.jpg'
import image_ah from '../images/artwork/spooky, disturbing, adult, dark, surreal.jpeg'
import image_ai from '../images/artwork/surreal, adult, disturbing.jpg'
import image_aj from '../images/artwork/surreal, edgy, spooky, adult.jpeg'
import image_ak from '../images/artwork/surreal, spooky.jpeg'
import image_al from '../images/artwork/woo-woo, soothing, professional.jpg'
import image_am from '../images/artwork/woo-woo, soothing.jpg'
import image_an from '../images/artwork/woo-woo.jpg'
import image_ao from '../images/artwork/woo-woo,.jpg'
import image_ap from '../images/artwork/young, friendly, clean.png'
import image_aq from '../images/artwork/young, friendly, silly, clean.jpg'

import { ImageQuestionType } from '../components/ImageQuestion'
import { SliderQuestionType } from '../components/SliderQuestion'
import { TextQuestionType } from '../components/TextQuestion'
import { CategoryFeatureDictType } from './features'
import { OptionId, OptionType } from './options'

export type GenericQuestion = {
  question_text: string
  pretext?: string
  subtext?: string
  shuffle?: boolean
  option_items: TempOptionType[]
}

export type Truthy<T> = T extends false | '' | 0 | null | undefined ? never : T
export const isTruthy = <T extends unknown>(value: T): value is Truthy<T> =>
  Boolean(value)

export const shuffleArray = <T extends unknown>(array: Array<T>): Array<T> => {
  for (let i = array.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1))
    ;[array[i], array[j]] = [array[j], array[i]]
  }
  return array
}

export const podcast_cover_content = [
  {
    content: image_a,
    name: '',
    features: { 'podcast_tone>casual': 1, 'podcast_tone>surreal': 1 },
  },
  {
    content: image_b,
    name: '',
    features: {
      'podcast_tone>adult': 1,
      'podcast_tone>disturbing': 1,
      'podcast_tone>dark': 1,
    },
  },
  {
    content: image_c,
    name: '',
    features: {
      'podcast_tone>adult': 1,
      'podcast_tone>edgy': 1,
      'podcast_tone>dark': 1,
    },
  },
  {
    content: image_d,
    name: '',
    features: {
      'podcast_tone>adult': 1,
      'podcast_tone>scholarly': 1,
      'podcast_tone>professional': 1,
    },
  },
  {
    content: image_e,
    name: '',
    features: {
      'podcast_tone>clean': 1,
      'podcast_tone>silly': 1,
      'podcast_tone>cheerful': 1,
      'podcast_tone>young': 1,
    },
  },
  {
    content: image_f,
    name: '',
    features: {
      'podcast_tone>dark': 1,
      'podcast_tone>spooky': 1,
      'podcast_tone>disturbing': 1,
      'podcast_tone>adult': 1,
    },
  },
  {
    content: image_g,
    name: '',
    features: {
      'podcast_tone>edgy': 1,
      'podcast_tone>adult': 1,
      'podcast_tone>funny': 1,
      'podcast_tone>casual': 1,
    },
  },
  {
    content: image_h,
    name: '',
    features: {
      'podcast_tone>edgy': 1,
      'podcast_tone>adult': 1,
      'podcast_tone>funny': 1,
    },
  },
  {
    content: image_i,
    name: '',
    features: {
      'podcast_tone>edgy': 1,
      'podcast_tone>surreal': 1,
      'podcast_tone>professional': 1,
    },
  },
  {
    content: image_j,
    name: '',
    features: {
      'podcast_tone>funny': 1,
      'podcast_tone>edgy': 1,
      'podcast_tone>casual': 1,
      'podcast_tone>adult': 1,
    },
  },
  {
    content: image_k,
    name: '',
    features: { 'podcast_tone>funny': 1, 'podcast_tone>edgy': 1 },
  },
  {
    content: image_l,
    name: '',
    features: {
      'podcast_tone>funny': 1,
      'podcast_tone>silly': 1,
      'podcast_tone>cheerful': 1,
      'podcast_tone>friendly': 1,
      'podcast_tone>young': 1,
    },
  },
  {
    content: image_m,
    name: '',
    features: {
      'podcast_tone>inspirational': 1,
      'podcast_tone>cheerful': 1,
      'podcast_tone>clean': 1,
      'podcast_tone>friendly': 1,
    },
  },
  {
    content: image_n,
    name: '',
    features: {
      'podcast_tone>inspirational': 1,
      'podcast_tone>clean': 1,
      'podcast_tone>young': 1,
      'podcast_tone>friendly': 1,
    },
  },
  {
    content: image_o,
    name: '',
    features: {
      'podcast_tone>inspirational': 1,
      'podcast_tone>professional': 1,
    },
  },
  { content: image_p, name: '', features: { 'podcast_tone>inspirational': 1 } },
  {
    content: image_q,
    name: '',
    features: { 'podcast_tone>professional': 1, 'podcast_tone>adult': 1 },
  },
  { content: image_r, name: '', features: { 'podcast_tone>professional': 1 } },
  {
    content: image_s,
    name: '',
    features: {
      'podcast_tone>raw': 1,
      'podcast_tone>adult': 1,
      'podcast_tone>dark': 1,
    },
  },
  {
    content: image_t,
    name: '',
    features: { 'podcast_tone>scholarly': 1, 'podcast_tone>adult': 1 },
  },
  {
    content: image_u,
    name: '',
    features: { 'podcast_tone>scholarly': 1, 'podcast_tone>casual': 1 },
  },
  {
    content: image_v,
    name: '',
    features: {
      'podcast_tone>scholarly': 1,
      'podcast_tone>cheerful': 1,
      'podcast_tone>casual': 1,
      'podcast_tone>friendly': 1,
    },
  },
  {
    content: image_w,
    name: '',
    features: { 'podcast_tone>scholarly': 1, 'podcast_tone>professional': 1 },
  },
  { content: image_x, name: '', features: { 'podcast_tone>scholarly': 1 } },
  { content: image_y, name: '', features: { 'podcast_tone>scholarly': 1 } },
  {
    content: image_z,
    name: '',
    features: {
      'podcast_tone>sexy': 1,
      'podcast_tone>adult': 1,
      'podcast_tone>casual': 1,
    },
  },
  {
    content: image_aa,
    name: '',
    features: { 'podcast_tone>sexy': 1, 'podcast_tone>adult': 1 },
  },
  {
    content: image_ab,
    name: '',
    features: {
      'podcast_tone>sexy': 1,
      'podcast_tone>edgy': 1,
      'podcast_tone>casual': 1,
    },
  },
  {
    content: image_ac,
    name: '',
    features: { 'podcast_tone>sexy': 1, 'podcast_tone>professional': 1 },
  },
  {
    content: image_ad,
    name: '',
    features: { 'podcast_tone>silly': 1, 'podcast_tone>funny': 1 },
  },
  {
    content: image_ae,
    name: '',
    features: {
      'podcast_tone>soothing': 1,
      'podcast_tone>clean': 1,
      'podcast_tone>friendly': 1,
    },
  },
  {
    content: image_af,
    name: '',
    features: { 'podcast_tone>soothing': 1, 'podcast_tone>clean': 1 },
  },
  { content: image_ag, name: '', features: { 'podcast_tone>soothing': 1 } },
  {
    content: image_ah,
    name: '',
    features: {
      'podcast_tone>spooky': 1,
      'podcast_tone>disturbing': 1,
      'podcast_tone>adult': 1,
      'podcast_tone>dark': 1,
      'podcast_tone>surreal': 1,
    },
  },
  {
    content: image_ai,
    name: '',
    features: {
      'podcast_tone>surreal': 1,
      'podcast_tone>adult': 1,
      'podcast_tone>disturbing': 1,
    },
  },
  {
    content: image_aj,
    name: '',
    features: {
      'podcast_tone>surreal': 1,
      'podcast_tone>edgy': 1,
      'podcast_tone>spooky': 1,
      'podcast_tone>adult': 1,
    },
  },
  {
    content: image_ak,
    name: '',
    features: { 'podcast_tone>surreal': 1, 'podcast_tone>spooky': 1 },
  },
  {
    content: image_al,
    name: '',
    features: {
      'podcast_tone>woo_woo': 1,
      'podcast_tone>soothing': 1,
      'podcast_tone>professional': 1,
    },
  },
  {
    content: image_am,
    name: '',
    features: { 'podcast_tone>woo_woo': 1, 'podcast_tone>soothing': 1 },
  },
  { content: image_an, name: '', features: { 'podcast_tone>woo_woo': 1 } },
  { content: image_ao, name: '', features: { 'podcast_tone>woo_woo': 1 } },
  {
    content: image_ap,
    name: '',
    features: {
      'podcast_tone>young': 1,
      'podcast_tone>friendly': 1,
      'podcast_tone>clean': 1,
    },
  },
  {
    content: image_aq,
    name: '',
    features: {
      'podcast_tone>young': 1,
      'podcast_tone>friendly': 1,
      'podcast_tone>silly': 1,
      'podcast_tone>clean': 1,
    },
  },
]

type Question = (ImageQuestionType | TextQuestionType | SliderQuestionType) & {
  options: OptionId[]
}

// Cant be in functions due to circular import
const numToSSColumn = (num: number) => {
  var s = ''
  var t: number

  while (num > 0) {
    t = (num - 1) % 26
    s = String.fromCharCode(65 + t) + s
    num = ((num - t) / 26) | 0
  }
  return s || undefined
}

// 0: "fiction_nonfiction>fiction"
// 1: "fiction_nonfiction>nonfiction"
// 2: "podcast_genre>instructional"
// 3: "podcast_genre>educational"
// 4: "podcast_genre>current_affairs"
// 5: "podcast_genre>entertainment_fiction"
// 6: "podcast_genre>entertainment_nonfiction"
// 7: "podcast_genre>experiential"
// 8: "podcast_genre>memoir"
// 9: "podcast_genre>community"
// 10: "podcast_genre>other_combination"
// 11: "hosting_style>solo_host_nonfiction"
// 12: "hosting_style>solo_host_fiction"
// 13: "hosting_style>cohost"
// 14: "hosting_style>collaborative_fiction"
// 15: "hosting_style>collaborative_nonfiction"
// 16: "hosting_style>minimal"
// 17: "hosting_style>other"
// 18: "publishing_schedule>finite"
// 19: "publishing_schedule>ongoing"
// 20: "publishing_schedule>seasonal_fluid"
// 21: "publishing_schedule>seasonal_non_fluid"
// 22: "podcast_tone>adult"
// 23: "podcast_tone>casual"
// 24: "podcast_tone>cheerful"
// 25: "podcast_tone>clean"
// 26: "podcast_tone>dark"
// 27: "podcast_tone>disturbing"
// 28: "podcast_tone>edgy"
// 29: "podcast_tone>friendly"
// 30: "podcast_tone>funny"
// 31: "podcast_tone>inspirational"
// 32: "podcast_tone>professional"
// 33: "podcast_tone>raw"
// 34: "podcast_tone>scholarly"
// 35: "podcast_tone>sexy"
// 36: "podcast_tone>silly"
// 37: "podcast_tone>soothing"
// 38: "podcast_tone>spooky"
// 39: "podcast_tone>surreal"
// 40: "podcast_tone>young"

const DEFAULT_QUESTION =
  'Select the artworks below that align best with the art you want to make.'

export type TempOptionType = {
  features: CategoryFeatureDictType
  name?: string
  content: string
}

const temp_questions_list: (
  | ImageQuestionType
  | TextQuestionType
  | SliderQuestionType
)[] = [
  {
    type: 'text',
    question_text: 'Real quick, will your podcast be fiction or nonfiction?',
    min_selections: 1,
    max_selections: 1,
    option_items: [
      {
        content: 'Fiction',
        features: {
          'fiction_nonfiction>fiction': 1,
          'fiction_nonfiction>nonfiction': 0,
        },
      },
      {
        content: 'Nonfiction',
        features: {
          'fiction_nonfiction>fiction': 0,
          'fiction_nonfiction>nonfiction': 1,
        },
      },
    ],
  },
  {
    type: 'text',
    question_text:
      'If your podcast were a television show, which station would it most likely broadcast on?',
    min_selections: 1,
    max_selections: 8,
    option_items: [
      {
        content: 'A News Station',
        features: {
          'podcast_genre>current_affairs': 1,
        },
      },
      {
        content: 'The Home Network',
        features: {
          'podcast_genre>instructional': 1,
        },
      },
      {
        content: 'PBS',
        features: {
          'podcast_genre>instructional': 1,
          'podcast_genre>educational': 1,
          'podcast_genre>entertainment_nonfiction': 1, //TODO: Could have this influence towards nonfiction
        },
      },
      {
        content: 'Showtime or HBO',
        features: {
          'podcast_genre>entertainment_fiction': 1,
        },
      },
      {
        // TODO Show the way that the question influences the answers (the features section when debugging)
        content: 'Comedy Central',
        features: {
          'podcast_genre>entertainment_fiction': 1,
          'podcast_genre>entertainment_nonfiction': 1,
        },
      },
      {
        content: 'The History Channel',
        features: {
          'podcast_genre>experiential': 1,
          'podcast_genre>memoir': 1,
        },
      },
      {
        content: "Harpo Studios (Oprah's Network)",
        features: {
          //TODO fail if the feature isnt existing
          'podcast_genre>community': 1,
          'podcast_genre>memoir': 1,
        },
      },
      {
        content: 'None. It’s too unique for television',
        // TODO Fail on a bad feature (other below)
        features: {
          // 'podcast_genre>other': 1,
          'podcast_genre>other_combination': 1,
        },
      },
    ],
  },
  {
    type: 'text',
    question_text:
      'If your podcast were a book, which section of the library would it most likely be shelved?',
    min_selections: 1,
    max_selections: 8,
    option_items: [
      {
        content: 'Children’s Stories',
        features: {
          'podcast_genre>entertainment_fiction': 1,
        },
      },
      {
        content: 'Current Events',
        features: {
          'podcast_genre>current_affairs': 1,
        },
      },
      {
        content: '"How-To" Section',
        features: {
          'podcast_genre>instructional': 1,
        },
      },
      {
        content: 'Memoir',
        features: {
          'podcast_genre>memoir': 1,
        },
      },

      {
        content: 'History',
        features: {
          'podcast_genre>educational': 1,
        },
      },
      {
        content: 'Cultural Affairs',
        features: {
          'podcast_genre>community': 1,
        },
      },
      {
        content: 'Fiction Novels or Short Stories',
        features: {
          'podcast_genre>entertainment_fiction': 1,
        },
      },
      {
        content: 'Nonfiction',
        features: {
          'podcast_genre>educational': 1,
        },
      },
      {
        content: 'Mystery',
        features: {
          'podcast_genre>entertainment_fiction': 1,
          'podcast_genre>entertainment_nonfiction': 1,
        },
      },
      {
        content: 'Abstract, avante-garde, beat-nick, or visual medium.',
        features: {
          'podcast_genre>experiential': 1,
        },
      },
      {
        content: 'None. It won’t fit on any shelf.',
        features: {
          'podcast_genre>other_combination': 1,
        },
      },
    ],
  },
  {
    type: 'text',
    question_text: 'What kind of host(s) will your podcast have?',
    min_selections: 1,
    max_selections: 1,
    option_items: [
      {
        content:
          'Practically none. The host isn’t central to the podcast at all. Listeners may never (or very rarely) hear their voice.',
        features: {
          'hosting_style>minimal': 1,
        },
      },
      {
        content: 'One main host. They’re the face of the podcast.',
        features: {
          'hosting_style>solo_host_nonfiction': 1,
          'hosting_style>solo_host_fiction': 1,
        },
      },
      {
        content: 'Two hosts share the mic together equally.',
        features: {
          'hosting_style>cohost': 1,
        },
      },
      {
        content: 'It’s a mixed bag of people sharing the mic each episode.',
        features: {
          'hosting_style>collaborative_fiction': 1,
          'hosting_style>collaborative_nonfiction': 1,
        },
      },
      {
        content: 'None of these answers fit what I’m envisioning at all.',
        features: {
          'hosting_style>other': 1,
        },
      },
    ],
  },
  {
    type: 'slider',
    question_text: 'How much presence will the host(s) have in the podcast?',
    option_items: [
      {
        content: 'None',
        features: {
          'hosting_style>other': 1,
        },
      },
      {
        content: 'Very minimal',
        features: {
          'hosting_style>minimal': 1,
        },
      },
      {
        content: "Some presence, but a lot of the time it's others speaking",
        features: {
          'hosting_style>collaborative_fiction': 1,
          'hosting_style>collaborative_nonfiction': 1,
        },
      },
      {
        content:
          'About half/half. The host(s) pipes in about as much as the others do',
        features: {
          'hosting_style>collaborative_fiction': 1,
          'hosting_style>collaborative_nonfiction': 1,
          'hosting_style>minimal': 1,
        },
      },
      {
        content:
          "Dominant. It's mostly the host(s) speaking, but with sprinkles of others piping in",
        features: {
          'hosting_style>solo_host_nonfiction': 1,
          'hosting_style>solo_host_fiction': 1,
          'hosting_style>cohost': 1,
        },
      },
      {
        content: "Complete. It's all host(s) and nothing else",
        features: {
          'hosting_style>solo_host_nonfiction': 1,
          'hosting_style>solo_host_fiction': 1,
        },
      },
    ],
  },
  {
    type: 'text',
    question_text:
      'How long do you envision creating content around your topic?',
    min_selections: 1,
    max_selections: 1,
    option_items: [
      {
        content:
          'I feel like I could talk about my topic forever and ever and ever.',
        features: {
          'publishing_schedule>ongoing': 1,
        },
      },
      {
        content:
          'I want to lay it all out, go deep, but after a year (give or take), I’ll be ready to move on to other projects',
        features: {
          'publishing_schedule>finite': 1,
        },
      },
      {
        content:
          'I could talk about this topic forever, but I know I’ll need to take long chunks of time off once or twice a year.',
        features: {
          'publishing_schedule>seasonal_fluid': 1,
        },
      },
      {
        content:
          'I could create content like this for a long time, but know I’ll need to change up the project/subject matter every year or so.',
        features: {
          'publishing_schedule>seasonal_non_fluid': 1,
        },
      },
    ],
  },
  {
    type: 'image',
    question_text:
      'Choose the cover art that best matches the mood you’d like to create on your own podcast.',
    pretext:
      'Below are several examples of existing podcast cover art. They each emote a different mood.',
    subtext: 'Don’t focus on the subject matter, just the mood of the artwork',
    shuffle: true,
    min_selections: 1,
    max_selections: 26,
    option_items: podcast_cover_content,
  },
]

let option_id = 0
type OptionsDictType = { [option: string]: OptionType | undefined }
export const optionsDict: OptionsDictType = temp_questions_list.reduce(
  (q_accu, question, q_idx) => {
    return {
      ...q_accu,
      ...question.option_items.reduce((o_accu, option) => {
        option_id += 1
        const letter = numToSSColumn(option_id)
        if (!letter) {
          throw new Error(`${letter}, ${option_id}, ${typeof option_id}`)
        }
        return {
          ...o_accu,
          [letter]: {
            ...option,
            id: letter,
            question: q_idx,
          },
        }
      }, {} as OptionsDictType),
    }
  },
  {} as OptionsDictType,
)
// console.log('optionsDict', optionsDict)

export const questions_list: Question[] = temp_questions_list.map(
  (question_item, index) => ({
    ...question_item,
    options: Object.keys(optionsDict).reduce((accu, o) => {
      if (optionsDict[o] === undefined) {
        throw new Error(`optionsDict is undefined for option: ${o}`)
      } else if (optionsDict[o]!.question === index) {
        if (question_item.shuffle) {
          return shuffleArray([...accu, o as OptionId])
        } else {
          return [...accu, o as OptionId]
        }
      }
      return accu
    }, [] as Array<OptionId>),
  }),
)

// console.log('questions_list', questions_list)
